import { useContext } from "react";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../../Helpers/Form/FormParts/FormHeader";
import { popupcontext } from "../../../../context/Popupscontext";
import OffcanvasFooter from "../../../Helpers/Offcanvasfooter/OffcanvasFooter";
import trans from "../../../../utils";
import ReportWorkforceInput from "../ReportSheetsInput/ReportWorkforceInput";
import Form from "../../../Helpers/Form/Form";
import { Formik } from "formik";
import { filtrationcontext } from "../../../../context/Filtercontext";

export default function ReportWorkforceFilter({
  setIsShown,
  isShown,
  filters,
  setFilters,
  onSubmit: handleFetchreport,
  reportType,
}) {
  const { form } = useContext(popupcontext);
  let { handleClose } = useContext(popupcontext);
  const { searchQuery } = useContext(filtrationcontext);

  const handleCancel = () => {
    handleClose();
    setIsShown(false);
  };
  return (
    <>
      <Formik
        initialValues={{
          startDate: filters.startDate ? filters.startDate : null,
          endDate: filters.endDate ? filters.endDate : null,
          serviceType: filters.serviceType ? filters.serviceType : [],
          status: filters.status ? filters.status : [],
          poiId: filters.poiId ? filters.poiId : [],
          assigneeIds: filters.assigneeIds ? filters.assigneeIds : [],
          requesterIds: filters.requesterIds ? filters.requesterIds : [],
          country: filters.country ? filters.country : "",
          state: filters.state ? filters.state : "",
          city: filters.city ? filters.city : "",
          technicianIds: filters.technicianIds ? filters.technicianIds : [],
          // min_assignments: filters.min_assignments ? filters.min_assignments : 0,
        }}
        enableReinitialize
        onSubmit={(values) => {
          setFilters(values);
          setIsShown(true);
          handleClose("form");
        }}
      >
        {({ values, setFieldValue, handleSubmit }) => (
          <Form show={form}>
            <Offcanvas.Header>
              <FormHeader title={trans("Report Filter")} />
            </Offcanvas.Header>
            <div className="H-line"></div>
            <Offcanvas.Body>
              <ReportWorkforceInput
                values={values}
                setFieldValue={setFieldValue}
                reportType={reportType}
              />
              <OffcanvasFooter
                text={trans("Show")}
                isShown={isShown}
                setIsShown={setIsShown}
                onClick={handleSubmit}
                onClose={handleCancel}
              />
            </Offcanvas.Body>
          </Form>
        )}
      </Formik>
    </>
  );
}
